import React from 'react';
import { StyledSelectArrayInput } from '@src/custom/Styled';

export const EXCLUDED_PRODUCT_LINES = ['Foremost Choice', 'Bristol West'];

const ProductsSelectInput = (props) => (
    <StyledSelectArrayInput
        groupBy="product_line"
        excludeProductLines={EXCLUDED_PRODUCT_LINES}
        {...props}
    />
);

export default React.memo(ProductsSelectInput);
